<script setup lang="ts">
const colorMode = useColorMode()
const { isAuthenticated } = useAuth()

const changeColorMode = () => {
  if (colorMode.value == 'light') {
    colorMode.value = 'dark'
    colorMode.preference = 'dark'
  } else {
    colorMode.value = 'light'
    colorMode.preference = 'light'
  }
}

const auth = useAuth()
</script>

<template>
  <header
    class="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur dark:border-slate-800 dark:bg-slate-950/70"
  >
    <UContainer class="flex h-16 items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="leading-tight">
          <p class="text-sm font-semibold text-slate-900 dark:text-slate-100">
            PureJoule
          </p>
          <p class="text-xs text-slate-500 dark:text-slate-400">
            Ogni joule conta. Ogni allenamento ha uno scopo.
          </p>
        </div>
      </div>

      <nav class="hidden items-center gap-6 md:flex">
        <a
          href="#manifesto"
          class="text-sm text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
        >Metodo</a>
        <a
          href="#about"
          class="text-sm text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
        >Chi sono</a>
        <a
          href="#risultati"
          class="text-sm text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
        >Risultati</a>
        <a
          href="#pacchetti"
          class="text-sm text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
        >Pacchetti</a>
        <a href="/blog" class="text-sm text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white">Blog</a>
        <a
          href="#faq"
          class="text-sm text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
        >FAQ</a>
        <a
          href="#contacts"
          class="text-sm text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
        >Contatti</a>
      </nav>
      <div class="flex items-center gap-2">
        <ClientOnly>
          <div class="flex items-center gap-2">
            <template v-if="!isAuthenticated">
              <NuxtLink
                to="/login"
                class="text-sm font-medium text-slate-900 hover:text-slate-700 dark:text-slate-100 dark:hover:text-slate-300"
              >
                Accedi
              </NuxtLink>
            </template>

            <NuxtLink v-else to="/dashboard">
              {{ auth?.user?.value?.email }}
            </NuxtLink>

            <UButton
              variant="ghost"
              class="hidden md:inline-flex text-slate-700 dark:text-slate-200"
              :icon="colorMode.value === 'dark' ? 'i-lucide-sun' : 'i-lucide-moon'"
              @click="changeColorMode"
            />
          </div>
        </ClientOnly>
      </div>
    </UContainer>
  </header>
</template>

<style scoped>

</style>
